import styled, { css } from 'styled-components'
import { HeaderCellProps } from './types'

export const Content = styled.td<HeaderCellProps>`
  background-color: white;
  gap: ${({ theme }) => theme.spacing.km4};
  height: 134px;
  display: flex;
  flex-flow: column;
  border: ${({ variant, theme }) => (variant === 'border' ? `1px solid ${theme.color.background.neutral.strong}` : '')};
  border-radius: ${({ variant, theme }) => (variant === 'border' ? theme.border.radius.default : '')};
  padding: ${({ theme, variant }) =>
    variant === 'default' ? `${theme.spacing.km4} ${theme.spacing.km5} 0px 0px` : theme.spacing.km6};

  ${({ variant }) =>
    variant !== 'default' &&
    css`
      align-items: center;
      justify-content: center;
    `}
`
